"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectAllGuardFloater = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const context_1 = require("@jsonjoy.com/ui/lib/styles/context");
const context_2 = require("../context");
const SelectAllGuardPopup_1 = require("./SelectAllGuardPopup");
const overlayClass = (0, nano_theme_1.rule)({
    pos: 'absolute',
    inset: 0,
    z: 1000,
    d: 'flex',
    fld: 'column',
    ai: 'center',
    jc: 'flex-start',
    bxz: 'border-box',
    WebkitBackdropFilter: 'saturate(180%) blur(10px)',
    backdropFilter: 'saturate(180%) blur(10px)',
    animation: 'guard-overlay-in .12s cubic-bezier(0.16,1,0.3,1) both',
    '@keyframes guard-overlay-in': {
        from: { opacity: 0 },
        to: { opacity: 1 },
    },
});
const dialogClass = (0, nano_theme_1.rule)({
    animation: 'guard-dialog-in .14s cubic-bezier(0.16,1,0.3,1) both',
    willChange: 'transform, opacity',
    '@keyframes guard-dialog-in': {
        from: { transform: 'translate3d(0,-12px,0)', opacity: 0 },
        to: { transform: 'translate3d(0,0,0)', opacity: 1 },
    },
});
/**
 * Modal-style overlay shown when the user is about to wipe a large document
 * via Ctrl+A then Backspace / Delete / typing.
 */
const SelectAllGuardFloater = () => {
    const mutxt = (0, context_2.useMuTxt)();
    const guard = mutxt.selectAllGuard;
    const open = guard.open.use();
    const action = guard.pending.use();
    const styles = (0, context_1.useStyles)();
    if (!open || !action)
        return null;
    // Frosted-glass tint over the shell.
    const overlayBg = styles.light ? 'rgba(245, 245, 245, 0.45)' : 'rgba(20, 20, 20, 0.45)';
    const onOverlayMouseDown = (event) => {
        // Only treat clicks on the backdrop itself as a cancel — clicks on the
        // dialog or its descendants must keep buttons interactive.
        if (event.target !== event.currentTarget)
            return;
        event.preventDefault();
        event.stopPropagation();
        guard.cancel();
    };
    const onDialogMouseDown = (event) => {
        // Suppress focus shifts that would otherwise move the contenteditable
        // selection while the dialog is open. Buttons inside still receive
        // click events because we only block mousedown's default.
        if (event.target.tagName !== 'INPUT')
            event.preventDefault();
        event.stopPropagation();
    };
    return (React.createElement("div", { className: overlayClass, style: { background: overlayBg }, role: "dialog", "aria-modal": "true", onMouseDown: onOverlayMouseDown },
        React.createElement("div", { className: dialogClass, onMouseDown: onDialogMouseDown },
            React.createElement(SelectAllGuardPopup_1.SelectAllGuardPopup, { state: guard, action: action }))));
};
exports.SelectAllGuardFloater = SelectAllGuardFloater;
